export default "__VITE_ASSET__CX33uVSl__"